import { Text, Flex } from '@chakra-ui/react';
import Editor from '@monaco-editor/react';
import { FormikProps } from 'formik';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { Select } from 'packages/common-frontend/components/Select';
import { ReportingPeriod } from '~/packages/creditAgreements/ui/ReportingPeriod';

type OrgProvidedInputConfigProps = {
  formProps: FormikProps<CreditAgreement.Config.CommonPostgresQuery.Query.OrgProvidedInputQuery>;
  keys: string[];
};
export const OrgProvidedInputConfig = ({
  formProps,
  keys,
}: OrgProvidedInputConfigProps) => {
  const selectOptions: {
    value: string;
    label: string;
  }[] = keys.map((el) => ({ value: el, label: el }));

  return (
    <Flex flexDir="column">
      <Text w="xs">Key:</Text>
      <Select
        value={formProps.values.parameterConfig.key.key}
        onChange={(val) => {
          formProps.setFieldValue('parameterConfig.key.key', val);
        }}
        options={selectOptions}
        width="xl"
      />

      <Flex flexDir="column" mt="3" mb="3">
        <Text>Reporting Date Formula:</Text>
        <Editor
          value={formProps.values.parameterConfig.reportingDateFormula.formula}
          onChange={(val) =>
            formProps.setFieldValue(
              'parameterConfig.reportingDateFormula.formula',
              val,
            )
          }
          width="100%"
          theme="vs-dark"
          height="15vh"
        />
      </Flex>

      <Flex>
        <ReportingPeriod
          reportingPeriod={
            formProps.values.parameterConfig.reportingPeriod.reportingPeriod
          }
          setReportingPeriod={(reportingPeriod) =>
            formProps.setFieldValue(
              'parameterConfig.reportingPeriod.reportingPeriod',
              reportingPeriod,
            )
          }
        />
      </Flex>
    </Flex>
  );
};
